const searchQueryParamName = "szukaj" as const;

export default searchQueryParamName;
